import React from "react";
import tw from "twin.macro"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";

import Hero from "components/hero/BackgroundAsImage.js";
import Features from "components/features/DashedBorderSixFeatures";
import MainFeature3 from "components/features/ThreeColCenteredStatsPrimaryBackground.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustration.js";
import Footer from "components/footers/MiniCenteredFooter.js";
// import customerSupportIllustrationSrc from "images/customer-support-illustration.svg";
import Parcels from "images/parcels.jpg";

export default () => (
  <AnimationRevealPage disabled>
    <Hero />
    <Features />
    <MainFeature3 />
    <ContactUsForm imageSrc={Parcels} />
    <Footer />
  </AnimationRevealPage>
);
